import React from 'react'
import {Page, Splitter, SplitterContent, ActionSheet, ActionSheetButton, Popover, AlertDialog, Switch, Row, Col} from 'react-onsenui'
import {withRouter} from "react-router-dom";
import Loader from 'react-loader-spinner';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import {NaverMap, Marker, Polyline} from 'react-naver-maps'
import connect from "react-redux/es/connect/connect";
import _ from "underscore";
import {Carousel} from 'react-responsive-carousel';

import {showAlertMessage} from "../../modules/alert";
import {showToastMessage} from "../../modules/toast";
import {useSearchNaverPlaceData, useNaverPlaceApiData, useNaverTrafficConditionData, useCurrentLocation} from "../../modules/native";
import {GEO_LOCATION, GET_JOSA, ENCODE_QUERY_DATA, CHECK_ANONYMOUS, PROCESS_TO_CREATE_SCHEDULE_DATA, SVG_MARKER_ICON, DEFAULT_GPS_LOCATION, NAVER_THUMBNAIL_GETTER, GET_HEIGHT_FOR_NAVER_MAP} from "../../modules/variable/common_variable";
import NaverPlaceReviewsActionSheet from '../schedule/module/naverPlaceReviewsActionSheet';
import RoadViewActionSheet from '../schedule/module/roadViewActionSheet';
import InterestingPlaceActionSheet from '../schedule/module/interestingPlaceActionSheet';
import {showTutorial} from "../../modules/tutorial";

class CreateSchedule extends React.Component {
    constructor(props) {
        super(props);

        let defaultLocation = DEFAULT_GPS_LOCATION;
        let defaultZoom = 8;
        if(localStorage.getItem('savedDefaultLocation')){
            try {
                defaultLocation = JSON.parse(localStorage.getItem('savedDefaultLocation'));
            } catch (e) {
                console.error(e);
            }
        }
        if(localStorage.getItem('savedDefaultZoom')){
            try {
                defaultZoom = parseInt(localStorage.getItem('savedDefaultZoom'));
            } catch (e) {
                console.error(e);
            }
        }

        let agreedShareSchedule = true;
        if(localStorage.getItem('agreedShareSchedule')){
            try {
                agreedShareSchedule = (localStorage.getItem('agreedShareSchedule') === 'true');
            } catch (e) {
                console.error(e);
            }
        }

        let editShareSchedule = true;
        if(localStorage.getItem('editShareSchedule')){
            try {
                editShareSchedule = (localStorage.getItem('editShareSchedule') === 'true');
            } catch (e) {
                console.error(e);
            }
        }

        let defaultSearchCount = 30;
        if(localStorage.getItem('savedSearchCount')){
            try {
                defaultSearchCount = localStorage.getItem('savedSearchCount');
            } catch (e) {
                console.error(e);
            }
        }

        this.state = {
            mapCenter: defaultLocation,
            targetToMapCenter: null,
            tabBarTarget: 'playing',
            searchedPlaces: {isLoading: false, total: 0, index: 0, playing: [], eating: [], accommodation: []},
            defaultZoom: defaultZoom,
            zoomLevel: 10,
            showZoomLevelNotification: false,
            showExecuteSearchButton: false,
            lockMapArea: true,
            searchBounds: null,
            searchCount: defaultSearchCount,
            searchTypeActionSheet: {
                open: false,
                title: '놀곳 종류',
                target: 'playing_sort',
                selected: {playing_sort: {cid: 'all', name: '전체'}, eating_sort: {cid: 'all', name: '전체'}, eating_theme: {cid: 'all', name: '전체'}, accommodation_sort: {cid: 'all', name: '전체'}},
                list: {
                    playing_sort: [
                        {cid: 'all', name: '전체'},
                        {cid: 'themePark', name: '테마파크'},
                        {cid: '워터파크', name: '워터파크'},
                        {cid: 'culturalAssets', name: '문화재'},
                        {cid: 'experienceVillage', name: '체험마을'},
                        {cid: 'naturalAttractions', name: '자연명소'},
                        {cid: 'localAttractions', name: '지역명소'},
                        {cid: 'park', name: '공원'},
                        {cid: 'museum', name: '박물관'},
                        {cid: 'artMuseum', name: '미술관'},
                        {cid: 'scienceMuseum', name: '과학관'},
                        {cid: 'zoo', name: '동물원'},
                    ],
                    eating_sort: [
                        {cid: 'all', name: '전체'},
                        {cid: '7', name: '카페'},
                        {cid: '1', name: '한식'},
                        {cid: '2', name: '양식'},
                        {cid: '3', name: '아시아음식'},
                        {cid: '4', name: '일식'},
                        {cid: '5', name: '중식'},
                        {cid: '6', name: '분식'},
                        {cid: '8', name: '뷔페'},
                        {cid: '9', name: '기타'}
                    ],
                    eating_theme: [
                        {cid: 'all', name: '전체'},
                        {cid: '3', name: '아이와함께'},
                        {cid: '1', name: '조용한분위기'},
                        {cid: '2', name: '젊고캐쥬얼한'},
                        {cid: '4', name: '모임하기좋은'},
                        {cid: '5', name: '특별한날'}
                    ],
                    accommodation_sort: [
                        {cid: 'all', name: '전체'},
                        {cid: 'resort', name: '리조트'},
                        {cid: 'pension', name: '팬션'},
                        {cid: 'hotel', name: '호텔'},
                        {cid: 'guest', name: '게스트 하우스'}
                    ]
                },
                nameToTile: {playing: '놀곳', eating: '먹을곳', accommodation: '잘곳'}
            },
            expectedScheduleActionSheet: {
                show: false,
                list: [] // TEMP_SCHEDULE //[]
            },
            targetNaverPlaceActionSheet: {
                targetMarker: null,
                open: false,
                isLoading: false,
                data: null,
                chosenThumbnailType: 'map'
            },
            naverPlaceReviewsActionSheet: {open: false, targetMarker: null},
            iframeActionSheet: {open: false, frameUrl: null},
            targetNaverPlacePopover: {open: false, text: '', category: '', target: null},
            showExpectedSchedule: true,
            showPlaceLabel: true,
            showExpectedScheduleSetting: true,
            searchPlaceActionSheet: {open: false, text: '', range: 0, list: [], isLoading: false, onFocus: false},
            gpsLocation: null,
            trafficConditionActionSheet: {
                open: false,
                isLoading: false,
                list: [],
                parameters: {}
            },
            saveScheduleDialog: {open: false, title: '', description: '', thumbnailIndex: 0, inputTag: '', tags:[], agree: agreedShareSchedule, edit: editShareSchedule, isLoading: false,
                sort: {date: false, picnic: false, sightseeing: false, shopping: false, eating: false, history: false, study: false, healing: false, activity: false, sport: false, outside: false, inside: false}},
            roadViewActionSheet: {open: false, frameUrl: null},
            interestingPlaceActionSheet: {open: false},
            expectedScheduleWithTypeSelectionActionSheet: {open: false, target: null},
        };
    }

    naverMaps = window.naver.maps;

    componentDidMount() {
        //check is editing
        if(this.props.edit){
            this.getEditingData(this.props.expectedSchedule);
        }

        setTimeout(() => {
            try {
                this.searchPlaces(this.naverMapRef.map.getBounds(), 0, true);
            } catch (e) {
                console.error(e);
                const defaultBounds = {"_min":{"y":37.5593619,"_lat":37.5593619,"x":126.969947,"_lng":126.969947},"_sw":{"y":37.5593619,"_lat":37.5593619,"x":126.969947,"_lng":126.969947},"_max":{"y":37.5738581,"_lat":37.5738581,"x":126.9868311,"_lng":126.9868311},"_ne":{"y":37.5738581,"_lat":37.5738581,"x":126.9868311,"_lng":126.9868311}};
                setTimeout(() => {
                    this.searchPlaces(defaultBounds, 0, true);
                }, 500);
            }

        }, 500);

        if(!localStorage.getItem('CONFIRMED_TUTORIAL_CREATE_SCHEDULE')){
            this.props.showTutorial('CREATE_SCHEDULE');
            localStorage.setItem('CONFIRMED_TUTORIAL_CREATE_SCHEDULE', "true");
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.edit && (JSON.stringify(this.props.expectedSchedule) !== (JSON.stringify(nextProps.expectedSchedule)))){
            this.getEditingData(nextProps.expectedSchedule);
        }

        if(this.props.usedSearchNaverPlaceData === true && nextProps.usedSearchNaverPlaceData === false){
            const target = nextProps.searchNaverPlaceTarget;
            switch (target){
                case 'SEARCH':
                    this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, isLoading: false, list: nextProps.searchNaverPlaceData.items}});
                    break;
                default:
                    const searchedPlacesItems = this.filterSearchedPlacesItems(nextProps.searchNaverPlaceTarget, nextProps.searchNaverPlaceData.items);
                    this.setState({searchedPlaces: {...this.state.searchedPlaces, [nextProps.searchNaverPlaceTarget]: searchedPlacesItems, isLoading: false, total: nextProps.searchNaverPlaceData.total}});
            }
            this.props.useSearchNaverPlaceData();
        }
        /*if(this.props.usedNaverPlaceApiData === true && nextProps.usedNaverPlaceApiData === false){
            switch (nextProps.naverPlaceApiTarget) {
                case 'PLACE_DETAIL':
                    this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, data: nextProps.naverPlaceApiData, isLoading: false}});
                    break;
                default:
                    console.error('NO TARGET');
            }

            this.props.useNaverPlaceApiData();
        }*/

        /*if(this.props.usedNaverTrafficConditionData === true && nextProps.usedNaverTrafficConditionData === false){
            const target = nextProps.naverTrafficConditionTarget;
            switch (target){
                case 'TOTAL_SCHEDULE':
                    alert(JSON.stringify(nextProps.naverTrafficConditionData));
                    this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, isLoading: false, data: nextProps.naverTrafficConditionData}});
                    break;
            }
            this.props.useNaverTrafficConditionData();
        }*/

        if(this.props.usedCurrentLocation === true && nextProps.usedCurrentLocation === false){
            this.setState({mapCenter: nextProps.currentLocation, gpsLocation: nextProps.currentLocation});
            this.props.useCurrentLocation();

            if(this.state.expectedScheduleActionSheet.open){
                this.showExpectedScheduleActionSheet();
            }
        }
    }

    componentWillMount() {

    }

    componentWillUnmount(){
    }

    getEditingData = (expectedSchedule) => {
        this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: expectedSchedule}});

        if(expectedSchedule.length !== 0){
            const target = expectedSchedule[0];
            const mapCenter = {y: target.y, x: target.x, lat: target.y, lng: target.x};

            let searchTags = this.props.docData.searchTags ? this.props.docData.searchTags : [];
            for(let i = 0; i < expectedSchedule.length; i ++){
                if(searchTags.indexOf(expectedSchedule[i].name) !== -1){
                    searchTags.splice(searchTags.indexOf(expectedSchedule[i].name), 1);
                }
            }

            let thumbnailIndex = this.props.docData.thumbnailIndex ? this.props.docData.thumbnailIndex : 0;
            let sort = this.props.docData.sort ? this.props.docData.sort : this.state.saveScheduleDialog.sort;
            this.setState({mapCenter: mapCenter, saveScheduleDialog: {...this.state.saveScheduleDialog, title: this.props.docData.title, description: this.props.docData.description, tags: searchTags, sort: sort, thumbnailIndex: thumbnailIndex}});
        }
    };

    fillInForm = (type, event) => {
        switch (type){
            case 'searchPlace':
                if(event.target.value.length <= 20) {
                    this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, text: event.target.value}});
                }else{
                    this.props.showToastMessage('20자 내로 검색해주시기 바립니다.');
                }
                break;
            case 'scheduleTitle':
                if(event.target.value.length <= 100) {
                    this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, title: event.target.value}});
                }else{
                    this.props.showToastMessage('100자 내로 입력해주시기 바립니다.');
                }
                break;
            case 'scheduleDescription':
                if(event.target.value.length <= 2000) {
                    this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, description: event.target.value}});
                }else{
                    this.props.showToastMessage('2000자 내로 입력해주시기 바립니다.');
                }
                break;
            case 'scheduleInputTag':
                if(event.target.value.length <= 20) {
                    this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, inputTag: event.target.value}});
                }else{
                    this.props.showToastMessage('20자 내로 입력해주시기 바립니다.');
                }
                break;
            default:
                console.error('NO TARGET');
        }
    };

    fillInFormInElement = (type, order, event) => {
        switch (type) {
            case 'elementUserComment':
                if(event.target.value.length <= 2000) {
                    let list = this.state.expectedScheduleActionSheet.list;
                    list[order].userComment = event.target.value;
                    this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list}});
                }else{
                    this.props.showToastMessage('2000자 내로 입력해주시기 바립니다.');
                }
                break;
            default:
                console.error('NO TARGET');
        }
    };

    searchPlaces = (boundsObject, index, isNew) => {

        let currentStart = (parseInt(this.state.searchCount) * index) + 1;

        this.setState({showExecuteSearchButton: false, searchedPlaces: {...this.state.searchedPlaces, isLoading: true, index: index}});
        if(isNew){
            this.setState({searchedPlaces: {...this.state.searchedPlaces, total: 0}});
        }

        const bounds = [boundsObject._min.x, boundsObject._min.y, boundsObject._max.x, boundsObject._max.y].join('%3B');
        let url = '';
        let display = this.state.searchCount;
        let queryString;
        const {tabBarTarget} = this.state;
        switch (tabBarTarget){
            case 'playing':
                const selectedPlayingSort = this.state.searchTypeActionSheet.selected.playing_sort;
                queryString = selectedPlayingSort.name;
                if(selectedPlayingSort.cid === 'all'){
                    queryString = '관광지';
                }
                /*if(['공원', '문화재'].indexOf(selectedPlayingSort.name.indexOf) !== -1) display = 100;*/
                url = 'https://store.naver.com/sogum/api/businesses?bounds=' + bounds + '&start=' + currentStart +'&display=' + display + '&query=' + encodeURI(queryString) + '&sortingOrder=reviewCount';
                break;
            case 'eating':
                url = 'https://store.naver.com/sogum/api/businesses?bounds=' + bounds + '&query=%EB%A7%9B%EC%A7%91&pageIndex=0&start=' + currentStart + '&display=' + display + '&sortingOrder=reviewCount';

                const selectedEatingSort = this.state.searchTypeActionSheet.selected.eating_sort;
                const selectedEatingTheme = this.state.searchTypeActionSheet.selected.eating_theme;
                if(selectedEatingSort.cid !== 'all'){
                    url = url + '&menu=' + selectedEatingSort.cid + '&category=' + encodeURI(selectedEatingSort.name);
                }
                if(selectedEatingTheme.cid !== 'all'){
                    url = url + '&context=' + selectedEatingTheme.cid + '&contextQuery=' + encodeURI(selectedEatingTheme.name);
                }
                break;
            case 'accommodation':
                const selectedAccommodationSort = this.state.searchTypeActionSheet.selected.accommodation_sort;
                queryString = selectedAccommodationSort.name;
                if(selectedAccommodationSort.cid === 'all'){
                    queryString = '숙박';
                }
                /*if(['호텔'].indexOf(selectedAccommodationSort.name.indexOf) !== -1) display = 100;*/

                switch (selectedAccommodationSort.cid){
                    case 'all':
                        url = 'https://store.naver.com/sogum/api/businesses?bounds=' + bounds + '&start=' + currentStart +'&display=' + display + '&query=' + encodeURI(queryString) + '&sortingOrder=reviewCount';
                        break;
                    case 'hotel':
                        url = 'https://store.naver.com/sogum/api/businesses?start=' + currentStart + '&display=' + display + '&bounds=' + bounds + '&isService=true&npay=true&pay=true&query=' + encodeURI(queryString) + '&so=review.dsc';
                        break;
                    case 'pension':
                        url = 'https://store.naver.com/sogum/api/businesses?start=' + currentStart + '&display=' + display + '&bounds=' + bounds + '&isService=true&npay=true&pay=true&query=' + encodeURI(queryString) + '&so=review.dsc';
                        break;
                    case 'resort':
                        url = 'https://store.naver.com/sogum/api/businesses?start=' + currentStart + '&display=' + display + '&bounds=' + bounds + '&query=' + encodeURI(queryString) + '&sortingOrder=reviewCount';
                        break;
                    case 'guest':
                        url = 'https://store.naver.com/sogum/api/businesses?start=' + currentStart + '&display=' + display + '&bounds=' + bounds + '&query=' + encodeURI(queryString) + '&sortingOrder=reviewCount';
                        break;
                    default:
                        console.error('NO TARGET');
                }
                break;
            default:
                this.setState({searchedPlaces: {...this.state.searchedPlaces, isLoading: false}});
        }

        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            url = url + '&level=bottom&deviceType=mobile';
            url = url.replace("https://store.naver.com", "https://m.store.naver.com");
        }else if(this.props.userInfo.ip){
            url = url + '&deviceType=pc&ip=' + this.props.userInfo.ip;
        }else{
            url = url + '&deviceType=pc';
        }

        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_SEARCH_NAVER_PLACE', 'url': url, target: tabBarTarget});
            window.postMessage(message, "*");
        }else if(window.isETView === true || window.isETView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_SEARCH_NAVER_PLACE', 'url': url, target: tabBarTarget});
            window.sendMessageToElectron(message);
        }else{
            const searchNaverPlace = firebase.functions().httpsCallable('searchNaverPlace');
            searchNaverPlace({url: url}).then((result) => {

                if(result.data.result === 'success'){
                    const data = JSON.parse(result.data.data);
                    const searchedPlacesItems = this.filterSearchedPlacesItems(tabBarTarget, data.items);
                    this.setState({searchedPlaces: {...this.state.searchedPlaces, isLoading: false, [tabBarTarget]: searchedPlacesItems, total: data.total}});
                }else{
                    this.props.showAlertMessage("정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.", "검색 오류");
                    this.setState({searchedPlaces: {...this.state.searchedPlaces, isLoading: false}});
                }
            });
        }

        //TEMP
        //this.setState({searchedPlaces: {...this.state.searchedPlaces, isLoading: false, [tabBarTarget]: TEMP_PLACES, total: 900}});
    };

    filterSearchedPlacesItems = (target, items) => {
        const cname = this.state.searchTypeActionSheet.selected[[target, 'sort'].join('_')].name;
        let filteredItems = [];

        switch (cname){
            case '공원':
                for(let i = 0; i < items.length; i++){
                    if(items[i].category && items[i].category.indexOf('공원') !== -1){
                        filteredItems.push(items[i]);
                    }
                }
                break;
            case '문화재':
                for(let i = 0; i < items.length; i++){
                    if(items[i].category && items[i].category.indexOf('부속') === -1){
                        filteredItems.push(items[i]);
                    }
                }
                break;
            case '호텔':
                for(let i = 0; i < items.length; i++){
                    if(items[i].category && items[i].category.indexOf('호텔') !== -1 && items[i].category.indexOf('반려') === -1 && items[i].category.indexOf('부속') === -1){
                        filteredItems.push(items[i]);
                    }
                }
                break;
            default:
                filteredItems = items;
        }

        if(filteredItems.length > this.state.searchCount){
            filteredItems = filteredItems.slice(0, this.state.searchCount);
        }

        return filteredItems;
    };

    changeTabBarTarget = (name) => {
        this.setState({tabBarTarget: name, showExecuteSearchButton: false});
        //this.setState({searchTypeActionSheet: {...this.state.searchTypeActionSheet, open: true, target: [name, 'sort'].join('_'), title: [this.state.searchTypeActionSheet.nameToTile[name],'종류'].join(' ')}});

        setTimeout(() => {
            this.searchPlaces(this.naverMapRef.map.getBounds(), 0, true);
        }, 500);
    };

    centerChangeListener = (mapCenter) => {
        try {
            localStorage.setItem('savedDefaultLocation', JSON.stringify({y: mapCenter.y, x: mapCenter.x}));
        } catch (e) {
            console.error(e);
        }

        this.setState({ mapCenter })
    };

    zoomChangeListener = (level) => {
        try {
            localStorage.setItem('savedDefaultZoom', level);
        } catch (e) {
            console.error(e);
        }

        this.setState({showZoomLevelNotification: false, zoomLevel: level});
    };

    handleBoundsChanged = (bounds) => {
        this.setState({showExecuteSearchButton: true, searchBounds: bounds});
    };

    requestCurrentLocation = () => {
        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_CURRENT_LOCATION'});
            window.postMessage(message, "*");
        }else{
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    //alert(position.coords.latitude + ' ' + position.coords.longitude);
                    const gpsLocation = {y: position.coords.latitude, x: position.coords.longitude, lat: position.coords.latitude, lng: position.coords.longitude};
                    this.setState({mapCenter:gpsLocation,  gpsLocation: gpsLocation});
                    localStorage.setItem('savedGpsLocation', JSON.stringify(gpsLocation));

                    if(this.state.expectedScheduleActionSheet.open){
                        this.showExpectedScheduleActionSheet();
                    }
                }, (error) => {
                    if(window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('192.168.') !== -1 ){
                        const testGpsLocation = {y: DEFAULT_GPS_LOCATION.lat, x: DEFAULT_GPS_LOCATION.lng, lat: DEFAULT_GPS_LOCATION.lat, lng: DEFAULT_GPS_LOCATION.lng};
                        this.setState({mapCenter: testGpsLocation, gpsLocation: testGpsLocation});
                        localStorage.setItem('savedGpsLocation', JSON.stringify(testGpsLocation));
                        if(this.state.expectedScheduleActionSheet.open){
                            this.showExpectedScheduleActionSheet();
                        }
                    }else{
                        console.error(error);
                        this.props.showToastMessage('위치 정보를 확인하는 과정에서 오류가 발생하였습니다.');
                    }
                }, {
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: Infinity
                });
            } else {
                this.props.showToastMessage('본 기기가 GPS를 지원하지 않습니다.');
            }
        }
    };

    selectSearchType = (target, cid) => {
        const selected = _.findWhere(this.state.searchTypeActionSheet.list[target], {cid: cid});
        this.setState({
            searchTypeActionSheet:
                {
                    ...this.state.searchTypeActionSheet,
                    open: false,
                    selected: {
                        ...this.state.searchTypeActionSheet.selected,
                        [target]: selected
                    }
                }
        });

        setTimeout(() => {
            this.searchPlaces(this.naverMapRef.map.getBounds(), 0, true);
        }, 500);
    };

    getSearchTypeList = () => {
        const {tabBarTarget} = this.state;
        let typeList = null;
        const selectSearchCount = <select className="select-input select-input--material create-plan-search-type-list-select" value={this.state.searchCount} onChange={(e) => this.changeSearchCount(e)}><option value={"10"}>10</option><option value={"20"}>20</option><option value={"30"}>30</option></select>;
        const searchPlaceButton = <button className="button button--material--flat create-plan-search-type-list-search TUTO_CREATE_SEARCH_BUTTON" onClick={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, open: true}})}><i className="fa fa-search"/></button>;

        switch (tabBarTarget){
            case 'playing':
                typeList = <li className="list-header create-plan-search-type-list">
                    <span>종류:</span> <button className="button button--material--flat TUTO_CREATE_SEARCH_TYPE_PLAYING" onClick={() => this.setState({searchTypeActionSheet: {...this.state.searchTypeActionSheet, open: true, target: 'playing_sort', title: '놀곳 종류'}})}>{this.state.searchTypeActionSheet.selected.playing_sort.name}</button>
                    {searchPlaceButton}
                    {selectSearchCount}
                </li>;
                break;
            case 'eating':
                typeList = <li className="list-header create-plan-search-type-list">
                    <span>종류:</span> <button className="button button--material--flat" onClick={() => this.setState({searchTypeActionSheet: {...this.state.searchTypeActionSheet, open: true, target: 'eating_sort', title: '먹을곳 종류'}})}>{this.state.searchTypeActionSheet.selected.eating_sort.name}</button>
                    <span>분위기·테마:</span> <button className="button button--material--flat" onClick={() => this.setState({searchTypeActionSheet: {...this.state.searchTypeActionSheet, open: true, target: 'eating_theme', title: '먹을곳 분위기·테마'}})}>{this.state.searchTypeActionSheet.selected.eating_theme.name}</button>
                    {searchPlaceButton}
                    {selectSearchCount}
                </li>;
                break;
            case 'accommodation':
                typeList = <li className="list-header create-plan-search-type-list">
                    <span>종류:</span> <button className="button button--material--flat" onClick={() => this.setState({searchTypeActionSheet: {...this.state.searchTypeActionSheet, open: true, target: 'accommodation_sort', title: '잘곳 종류'}})}>{this.state.searchTypeActionSheet.selected.accommodation_sort.name}</button>
                    {searchPlaceButton}
                    {selectSearchCount}
                </li>;
                break;
            default:
                console.error('NO TARGET');
        }
        return (
            typeList
        )
    };

    changeSearchCount = (event) => {
        this.setState({searchCount: event.target.value});
        localStorage.setItem('savedSearchCount', event.target.value);

        setTimeout(() => {
            this.searchPlaces(this.naverMapRef.map.getBounds(), 0, true);
        }, 500);
    };

    chooseNaverPlace = (marker) => {
        this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, targetMarker: marker, open: true, isLoading: false, data: null}});
        /*const url = 'https://m.store.naver.com/sogum/api/businesses/' + marker.id + '?businessType=attraction&viewType=detail&businessOnly=false&deviceType=mobile';

        setTimeout(() => {
            if(window.isRNWebView === true || window.isRNWebView === 'true'){
                const message = JSON.stringify({'type': 'REQUEST_NAVER_PLACE_API', 'url': url, target: 'PLACE_DETAIL'});
                window.postMessage(message, "*");
            }else{
                const searchNaverPlace = firebase.functions().httpsCallable('searchNaverPlace');
                searchNaverPlace({url: url}).then((result) => {
                    if(result.data.result === 'success'){
                        const data = JSON.parse(result.data.data);
                        console.log(data);
                        this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, isLoading: false, data: data}});
                    }else{
                        this.props.showAlertMessage("정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.", "검색 오류");
                        this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, isLoading: false, data: null}});
                    }
                });
            }
        }, 500)*/;
    };

    paginationSearchPlace = (index) => {
        this.searchPlaces(this.naverMapRef.map.getBounds(), index, false);
    };

    showExpectedScheduleActionSheet = () => {
        let list = this.getDistanceOfExpectedSchedule(this.state.expectedScheduleActionSheet.list);
        let gpsFrom = this.getDistanceFromGps(list);

        this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list, gpsFrom: gpsFrom, open: true}});
    };

    changeOrderExpectedSchedule = (direction, index) => {
        let previousList = this.state.expectedScheduleActionSheet.list;
        let newIndex = direction === 'up' ? index - 1 : index + 1;

        if (newIndex >= previousList.length) {
            var k = newIndex - previousList.length + 1;
            while (k--) {
                previousList.push(undefined);
            }
        }
        previousList.splice(newIndex, 0, previousList.splice(index, 1)[0]);

        let list = this.getDistanceOfExpectedSchedule(previousList);
        let gpsFrom = this.getDistanceFromGps(list);
        this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list, gpsFrom: gpsFrom}});
    };

    deleteExpectedSchedule = (index) => {
        let list = this.state.expectedScheduleActionSheet.list;
        if (window.confirm(list[index].name + GET_JOSA(list[index].name, '을') + " 삭제하시겠습니까?") === true){
            list.splice(index, 1);
            list = this.getDistanceOfExpectedSchedule(list);
            let gpsFrom = this.getDistanceFromGps(list);
            this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list, gpsFrom: gpsFrom}});
        }
    };

    getDistanceOfExpectedSchedule = (list) => {
        for(let i = 0; i <list.length; i ++){
            if(i !== 0 ){
                let distanceFrom = '0km';
                try {
                    let d = GEO_LOCATION.getDistance({latitude: list[i-1].y, longitude: list[i-1].x},{latitude: list[i].y, longitude: list[i].x});
                    if(d < 1){
                        distanceFrom = parseInt(d * 1000) + 'm';
                    }else{
                        distanceFrom = d.toFixed(1) + 'km'
                    }
                } catch (e) {
                    console.error(e);
                }
                list[i].distanceFrom = distanceFrom;
            }else{
                list[i].distanceFrom = null;
            }
        }
        return list;
    };

    getDistanceFromGps = (list) => {
        const savedGpsLocation  = localStorage.getItem('savedGpsLocation');
        let gpsLocation = DEFAULT_GPS_LOCATION;
        if(savedGpsLocation){
            try {
                gpsLocation = JSON.parse(savedGpsLocation);
            } catch (e) {
                console.error(e);
            }
        }

        //get distance from gps location with first && last
        let gpsFrom = null;
        if(list.length !== 0){
            let start = GEO_LOCATION.getDistance({latitude: gpsLocation.lat, longitude: gpsLocation.lng},{latitude: list[0].y, longitude: list[0].x});
            if(start < 1){start = parseInt(start * 1000) + 'm';}else{start = start.toFixed(1) + 'km'}
            let last = GEO_LOCATION.getDistance({latitude: gpsLocation.lat, longitude: gpsLocation.lng},{latitude: list[list.length - 1].y, longitude: list[list.length - 1].x});
            if(last < 1){last = parseInt(last * 1000) + 'm';}else{last = last.toFixed(1) + 'km'}
            gpsFrom = {start: start, last: last, hasGps: savedGpsLocation !== null};
        }
        return gpsFrom;
    };

    addExpectedSchedule = (event, e, type) => {
        event.stopPropagation();

        let element = e;
        /*if(type){
            element.type = type;
        }else{
            element.type = this.state.tabBarTarget;
        }*/
        element.type = '';
        element.desc = "";

        const previousList = this.state.expectedScheduleActionSheet.list;
        const list = previousList.concat(element);

        if(list.length > 20){
            this.props.showToastMessage('일정은 최대 20개까지 가능합니다.');
            return;
        }

        if(this.state.targetNaverPlaceActionSheet.open){
            this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list}, targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, open: false}});
        }else if(this.state.expectedScheduleWithTypeSelectionActionSheet.open){
            this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list}, expectedScheduleWithTypeSelectionActionSheet: {...this.state.expectedScheduleWithTypeSelectionActionSheet, open: false}});
        }else if(this.state.interestingPlaceActionSheet.open){
            this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list}, interestingPlaceActionSheet: {...this.state.interestingPlaceActionSheet, open: false}});
        }else{
            this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, list: list}});
        }

        const josa = GET_JOSA(e.name, '이');
        this.props.showToastMessage(e.name + josa + ' 일정에 추가되었습니다.');
    };

    searchPlaceWithText = (event) => {
        event.preventDefault();
        const spas = this.state.searchPlaceActionSheet;
        this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, isLoading: true, list: []}});

        if(spas.text.length < 2){
            this.props.showToastMessage('검색어를 2자 이상 입력해주시기 바랍니다.');
            return;
        }

        let url = 'https://store.naver.com/sogum/api/businesses?start=1&display=99&query=' + encodeURI(spas.text) + '&sortingOrder=reviewCount';
        if(this.props.userInfo.ip){
            url = url + '&deviceType=pc&ip=' + this.props.userInfo.ip;
        }else{
            url = url + '&deviceType=pc';
        }

        if(spas.range !== 0){
            const range = GEO_LOCATION.buildLocationRange(this.state.mapCenter.y || this.state.mapCenter.lat, this.state.mapCenter.x || this.state.mapCenter.lng, spas.range);
            const bounds = [range.minLon, range.minLat, range.maxLon, range.maxLat].join('%3B');
            url = url + '&bounds=' + bounds;
        }

        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_SEARCH_NAVER_PLACE', 'url': url, target: 'SEARCH'});
            window.postMessage(message, "*");
        }else if(window.isETView === true || window.isETView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_SEARCH_NAVER_PLACE', 'url': url, target: 'SEARCH'});
            window.sendMessageToElectron(message, "*");
        }else{
            const searchNaverPlace = firebase.functions().httpsCallable('searchNaverPlace');
            searchNaverPlace({url: url}).then((result) => {

                if(result.data.result === 'success'){
                    const data = JSON.parse(result.data.data);
                    this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, isLoading: false, list: data.items}});
                }else{
                    this.props.showAlertMessage("정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.", "검색 오류");
                    this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, isLoading: false}});
                }
            });
        }
    };

    showTrafficCondition = () => {
        const sl = this.state.expectedScheduleActionSheet.list;
        const savedGpsLocation  = localStorage.getItem('savedGpsLocation');
        let gpsLocation = DEFAULT_GPS_LOCATION;
        if(savedGpsLocation){
            try {
                gpsLocation = JSON.parse(savedGpsLocation);
            } catch (e) {
                console.error(e);
            }
        }

        let list = [];
        let prefix = 'https://m.map.naver.com/directions/?';

        for(let i = 0; i < sl.length; i ++){
            if(i === 0){
                let route = '내위치' + ' → ' + sl[0].name;
                let query = {menu: 'route', sy: gpsLocation.y, sx: gpsLocation.x, sname: '내위치', ey: sl[i].y, ex: sl[i].x, ename: sl[i].name, pathType: 0};
                list.push({route: route, url: prefix + ENCODE_QUERY_DATA(query)});
            }

            if(i !== 0){
                let route = sl[i - 1].name + ' → ' + sl[i].name;
                let query = {menu: 'route', sy: sl[i - 1].y, sx: sl[i - 1].x, sname: sl[i - 1].name, ey: sl[i].y, ex: sl[i].x, ename: sl[i].name, pathType: 0};
                list.push({route: route, url: prefix + ENCODE_QUERY_DATA(query)});
            }

            if(i === sl.length - 1){
                let route = sl[sl.length - 1].name + ' → ' + '내위치';
                let query = {menu: 'route', sy: sl[i].y, sx: sl[i].x, sname: sl[i].name, ey: gpsLocation.y, ex: gpsLocation.x, ename: '내위치', pathType: 0};
                list.push({route: route, url: prefix + ENCODE_QUERY_DATA(query)});
            }
        }

        this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, list: list, open: true}});

        /*const parameters = {start:{}, destination:{}, via:[]};

        let url = 'https://map.naver.com/spirra/findCarRoute.nhn?route=route3&output=json&result=web3&coord_type=naver&search=1&car=0';
        let start = '&start=' + [gpsLocation.x, gpsLocation.y, encodeURI("MINE")].join('%2C');
        let destination = '&destination=' + [gpsLocation.x, gpsLocation.y, encodeURI("MINE")].join('%2C');
        parameters.start = {x: gpsLocation.x, y: gpsLocation.y, name: 'MINE'};
        parameters.destination = {x: gpsLocation.x, y: gpsLocation.y, name: 'MINE'};

        let via = '&via=';
        for(let i = 0; i < sl.length; i ++){
            via = via + sl[i].x + '%2C' + sl[i].y + '%2C' + encodeURI(sl[i].name);
            if(i !== sl.length - 1){
                via  = via + '%2C';
            }

            parameters.via.push({x: sl[i].x, y: sl[i].y, name: sl[i].name});
        }

        url = url + start + destination + via;
        this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, isLoading: true}});

        console.log(url);

        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_NAVER_TRAFFIC_CONDITION', 'url': url, target: 'TOTAL_SCHEDULE'});
            window.postMessage(message, "*");
        }else{
            const getTrafficCondition = firebase.functions().httpsCallable('getTrafficCondition');
            getTrafficCondition({url: url}).then((result) => {

                if(result.data.result === 'success'){
                    const data = JSON.parse(result.data.data);
                    console.log(data);
                    //this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, isLoading: false, list: data.items}});
                }else{
                    this.props.showAlertMessage("정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.", "검색 오류");
                    //this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, isLoading: false}});
                }
            });
        }*/
    };

    //for test
    /*bundleIndex =1;
    saveSchedule = () => {
        if(CHECK_ANONYMOUS(this.props, true)){return false}

        const ssd = this.state.saveScheduleDialog;
        const sl = this.state.expectedScheduleActionSheet.list;

        if(ssd.title.length < 2){
            this.props.showToastMessage('이름을 2자 이상 입력해주시기 바랍니다.');
            return;
        }

        const so = PROCESS_TO_CREATE_SCHEDULE_DATA(_, sl);
        if(!so){
            this.props.showToastMessage('일정 저장 과정에서 문제가 발생하였습니다. 다시 시도해주시기 바랍니다.');
            return;
        }

        this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, isLoading: true}});

        firebase.auth().currentUser.getIdToken(true).then((token) => {
            //firebase.functions().useFunctionsEmulator('http://localhost:5000');
            const saveSchedule = firebase.functions().httpsCallable('saveSchedule');
            saveSchedule({token: token, nickname: this.props.userInfo.nickname, title: [this.bundleIndex,ssd.title].join('-'), description: ssd.description, so: so, share: ssd.agree, edit: ssd.edit}).then((result) => {
                if(result.data.result === 'success'){
                    if(this.bundleIndex < 52){
                        console.log(result);
                        this.bundleIndex = this.bundleIndex + 1
                        this.saveSchedule();
                    }else{
                        this.props.showToastMessage('일정 저장에 성공하였습니다.');
                        this.props.history.push("/home")
                    }

                }else{
                    console.error(result.data.message);
                    this.props.showToastMessage('일정 저장 과정에서 문제가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                    this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, isLoading: false, open: false}});
                }
            });
        })
            .catch(function (err) {
                console.error(err);
                this.props.showToastMessage('일정 저장 과정에서 문제가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, isLoading: false, open: false}});
            });
    };*/


    saveSchedule = () => {
        if(CHECK_ANONYMOUS(this.props, true)){return false}

        const ssd = this.state.saveScheduleDialog;
        const sl = this.state.expectedScheduleActionSheet.list;

        if(ssd.title.length < 2){
            this.props.showToastMessage('이름을 2자 이상 입력해주시기 바랍니다.');
            return;
        }

        const so = PROCESS_TO_CREATE_SCHEDULE_DATA(_, sl);
        if(!so){
            this.props.showToastMessage('일정 저장 과정에서 문제가 발생하였습니다. 다시 시도해주시기 바랍니다.');
            return;
        }

        this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, isLoading: true}});

        firebase.auth().currentUser.getIdToken(true).then((token) => {
                const saveSchedule = firebase.functions().httpsCallable('saveSchedule');
                let documentInformation = {isNew: true};
                if(this.props.edit && this.props.mine){
                    const DOC_ID = this.props.docData.DOC_ID;
                    const dateHistory = this.props.docData.dateHistory;
                    dateHistory.push(new Date().valueOf());
                    if(DOC_ID){
                        documentInformation = {isNew: false, DOC_ID: DOC_ID, dateHistory: dateHistory}
                    }else{
                        this.props.showToastMessage('일정 정보에 문제가 있어 수정할 수 없습니다.');
                        return;
                    }
                }

                let searchTags = this.state.saveScheduleDialog.tags;
                searchTags = searchTags.concat(_.pluck(sl, 'name'));

                /*let ts = {token: token, nickname: this.props.userInfo.nickname, title: ssd.title, description: ssd.description, searchTags: searchTags, thumbnailIndex: ssd.thumbnailIndex, so: so, share: ssd.agree, edit: ssd.edit, sort: ssd.sort, documentInformation: documentInformation};
                console.log(ts);
                console.log(JSON.stringify(ts));
                return;*/

                saveSchedule({token: token, nickname: this.props.userInfo.nickname, title: ssd.title, description: ssd.description, searchTags: searchTags, thumbnailIndex: ssd.thumbnailIndex, so: so, share: ssd.agree, edit: ssd.edit, sort: ssd.sort, documentInformation: documentInformation}).then((result) => {
                    if(result.data.result === 'success'){
                        this.props.showToastMessage('일정 저장에 성공하였습니다.');

                        this.props.history.push({
                            pathname: '/listSchedule',
                            state: {type: 'MINE', parameter: null}
                        });
                    }else{
                        console.error(result.data.message);
                        this.props.showToastMessage('일정 저장 과정에서 문제가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                        this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, isLoading: false, open: false}});
                    }
                });
            })
            .catch((err) => {
                console.error(err);
                this.props.showToastMessage('일정 저장 과정에서 문제가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, isLoading: false, open: false}});
            });
    };

    addSaveScheduleSearchTag = (event) => {
        event.preventDefault();
        let ssd = this.state.saveScheduleDialog;

        if(ssd.inputTag.trim().length < 2){
            this.props.showToastMessage('검색어는 2자 이상 입력하시기 바랍니다.');
            return;
        }
        if(ssd.tags.indexOf(ssd.inputTag) !== -1){
            this.props.showToastMessage('동일한 검색어가 이미 등록되어 있습니다.');
            return;
        }

        ssd.tags.push(ssd.inputTag);
        this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, tags: ssd.tags, inputTag: ''}});
    };

    deleteSaveScheduleSearchTag = (index) => {
        let ssd = this.state.saveScheduleDialog;

        if (window.confirm("검색어 " + ssd.tags[index] +  GET_JOSA(ssd.tags[index], '을') +" 삭제하시겠습니까?") === true){
            ssd.tags.splice(index, 1);
            this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, tags: ssd.tags}});
        }
    };

    openSaveScheduleDialog = () => {
        if(CHECK_ANONYMOUS(this.props, true)){return false}

        const sl = this.state.expectedScheduleActionSheet.list;
        if(sl === 0){
            this.props.showToastMessage('하나 이상의 일정이 필요합니다.');
            return;
        }
        const title = this.state.saveScheduleDialog.title === '' ? sl[0].name +  ' - ' + sl[sl.length - 1].name + ' [' + sl.length + '건]' : this.state.saveScheduleDialog.title;
        const thumbnailIndex = this.state.saveScheduleDialog.thumbnailIndex + 1 > sl.length ? 0 : this.state.saveScheduleDialog.thumbnailIndex;
        this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, open: true, title: title, thumbnailIndex: thumbnailIndex}});
    };

    changeShareSchedule = (agree, type) => {
        if(type === 'share'){
            localStorage.setItem('agreedShareSchedule', agree);
            this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, agree: agree}});

            if(!agree){
                localStorage.setItem('editShareSchedule', agree);
                this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, edit: false}});
            }
        }else if(type === 'edit'){
            localStorage.setItem('editShareSchedule', agree);
            this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, edit: agree}});
        }
    };

    searchPlaceFromHere = () => {
        this.setState({showExecuteSearchButton: false});
        setTimeout(() => {
            this.searchPlaces(this.state.searchBounds, 0, true)
        }, 500)
    };

    setTargetToMapCenter = (event, target) => {
        event.preventDefault();
        event.stopPropagation();

        const mapCenter = {y: target.y, x: target.x, lat: target.y, lng: target.x};
        this.setState({mapCenter: mapCenter, targetToMapCenter: mapCenter});
        setTimeout(() => {
            this.setState({targetToMapCenter: null});
        }, 2000)
    };

    showNaverPlaceReviewsActionSheet = (event, marker) => {
        event.stopPropagation();
        this.setState({naverPlaceReviewsActionSheet: {open: true, targetMarker: marker}});
    };

    addInterestingPlace = (marker) => {
        //console.log(marker);
        let parsedInterestingPlace = [];
        if(localStorage.getItem('savedInterestingPlace')){
            try {
                parsedInterestingPlace = JSON.parse(localStorage.getItem('savedInterestingPlace'));
            } catch (e) {console.error(e);}
        }

        if(!_.findWhere(parsedInterestingPlace, {id: marker.id})){
            let placeInformation = marker;
            placeInformation.type = this.state.tabBarTarget;
            parsedInterestingPlace.push(placeInformation);
            localStorage.setItem('savedInterestingPlace', JSON.stringify(parsedInterestingPlace));
            this.props.showToastMessage('관심 장소에 추가되었습니다.');
        }else{
            this.props.showToastMessage('이미 추가한 관심 장소입니다.');
        }
    };

    addExpectedScheduleWithTypeSelection = (event, e) => {
        event.stopPropagation();
        //this.setState({expectedScheduleWithTypeSelectionActionSheet: {...this.state.expectedScheduleWithTypeSelectionActionSheet, open: true, target: e}});
        this.addExpectedSchedule(event, e, '');
        this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, open: false}});
    };

    changeSortOfSchedule = (type, checked) => {
        let sort = this.state.saveScheduleDialog.sort;
        let checkedCount = 0;
        if(checked){
            for (let key in sort) {
                if (sort.hasOwnProperty(key) && sort[key] === true) {
                    checkedCount++;
                }
            }
            if(checkedCount >= 4){
                this.props.showToastMessage('유형은 최대 4개까지 선택 가능합니다.');
                return;
            }
        }

        for (let key in sort) {
            if (sort.hasOwnProperty(key) && key === type) {
                sort[type] = checked;
            }
        }

        this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, sort: sort}});
    };

    render() {
        //console.log(this.state.expectedScheduleActionSheet.list);
        //console.log(this.props.userInfo)
        //console.log(JSON.stringify(this.state.expectedScheduleActionSheet.list));

        const naverMapPolyLineList = [];
        this.state.expectedScheduleActionSheet.list.map((e, i) => {
            naverMapPolyLineList.push(new this.naverMaps.LatLng(e.y, e.x));
        });

        const tnpas = this.state.targetNaverPlaceActionSheet;
        const esas = this.state.expectedScheduleActionSheet;

        return (
            <Splitter>
                <SplitterContent>
                    <Page>
                        <div className="toolbar toolbar--transparent">
                            <div className="toolbar__left">
                                <span className="toolbar-button" onClick={() => this.props.history.goBack()}>
                                    <i className="ion-ios-arrow-left"></i>
                                </span>
                                <span className="toolbar-button" onClick={() => this.props.history.push('/home')}>
                                    <i className="ion-ios-home"/>
                                </span>
                            </div>
                            <div className="toolbar__center">
                                일정 {this.props.edit && this.props.mine ? '수정' : '만들기'}
                            </div>
                            <div className="toolbar__right">
                                <span className="toolbar-button" onClick={() => this.props.showTutorial('CREATE_SCHEDULE')}>
                                    <i className="fa fa-question-circle-o" style={{fontSize: '18px', lineHeight: '18px',verticalAlign: 'top', marginTop: '13px'}}/>
                                </span>
                            </div>
                        </div>
                        <div className={["create-plan-area", this.state.lockMapArea ? "create-pan-area-lock-map" : ""].join(" ")}>
                            {/*<p>lat: {this.state.mapCenter.y || this.state.mapCenter.lat}</p>
                            <p>lng: {this.state.mapCenter.x || this.state.mapCenter.lng}</p>*/}
                            <NaverMap
                                id={'naver-map'}
                                className={'naver--map create-plan-naver-map TUTO_CREATE_NAVER_MAP'}
                                naverRef={ref => { this.naverMapRef = ref }}
                                style={{width: '100%', height: GET_HEIGHT_FOR_NAVER_MAP(window.screenSizeProperty === 'md' ? 450 : 300)}}
                                defaultZoom={this.state.defaultZoom}
                                minZoom={3}
                                maxZoom={14}
                                zoomControl={true}
                                zoomControlOptions={
                                    {position: this.naverMaps.Position.TOP_RIGHT, style: this.naverMaps.ZoomControlStyle.SMALL, legendDisabled: false}
                                }

                                // controlled center
                                // Not defaultCenter={this.state.center}
                                center={this.state.mapCenter}
                                onCenterChanged={this.centerChangeListener}
                                onZoomChanged={this.zoomChangeListener}
                                onBoundsChanged={this.handleBoundsChanged}
                                logoControl={false}
                                mapDataControl={false}
                            >
                                <button className="button button--material--flat create-plan-map-current-button" onClick={this.requestCurrentLocation}>
                                    <i className="ion ion-android-locate"/>
                                </button>
                                {/*<label className="checkbox checkbox--material create-plan-map-my-schedule-button">
                                    <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.showExpectedSchedule} onChange={() => this.setState({showExpectedSchedule: this.state.showExpectedSchedule ? false: true})}/>
                                    <div className="checkbox__checkmark checkbox--material__checkmark"></div>일정
                                </label>
                                <label className="checkbox checkbox--material create-plan-map-show-label-button">
                                    <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.showPlaceLabel} onChange={() => this.setState({showPlaceLabel: this.state.showPlaceLabel ? false: true})}/>
                                    <div className="checkbox__checkmark checkbox--material__checkmark"></div>이름
                                </label>*/}
                                <button className="button button--material create-plan-map-execute-search-button" onClick={this.searchPlaceFromHere} style={this.state.showExecuteSearchButton ? {} : {display: 'none'}}>
                                    <i className="ion ion-refresh"/> 여기에서 검색
                                </button>

                                {
                                    this.state.searchedPlaces.isLoading ?
                                        <div className='create-plan-map-loader-puff'>
                                            <Loader type="ThreeDots" color="#00BFFF" height={80} width={80} />
                                        </div>
                                        :
                                        null
                                }

                                {
                                    this.state.searchedPlaces[this.state.tabBarTarget].map((e, i) => {
                                        return (
                                            <Marker key={['marker', e.id, i].join('_')}
                                                position={new this.naverMaps.LatLng(e.y, e.x)}
                                                icon= {
                                                    {content:
                                                            this.state.showPlaceLabel && _.findWhere(esas.list, {id: e.id}) === undefined ?
                                                                ['<div class="naver-map-pin naver-map-pin-', this.state.tabBarTarget, '">',
                                                                    '<span data-balloon-visible data-balloon="', e.name, '" data-balloon-pos="up" data-balloon-type="marker">',
                                                                         i + 1,
                                                                    '</span>',
                                                                '</div>'
                                                                ].join('')
                                                                :
                                                                ['<div class="naver-map-pin naver-map-pin-', this.state.tabBarTarget, '">',
                                                                    i + 1,
                                                                    '</span>',
                                                                    '</div>'
                                                                ].join('')
                                                    }
                                                }
                                                /*animation={this.naverMaps.Animation.BOUNCE}*/
                                                onClick={() => {
                                                    this.chooseNaverPlace(e)
                                                }}
                                            />
                                        )
                                    })
                                }

                                {
                                    this.state.showExpectedSchedule ?
                                        esas.list.map((e, i) => {
                                            return (
                                                <Marker key={['scheduled', 'marker', e.id, i].join('_')}
                                                        position={new this.naverMaps.LatLng(e.y, e.x)}
                                                        icon= {
                                                            {content: ['<div class="naver-map-pin-mine"',
                                                                    'id="',
                                                                    ['scheduled', 'marker', e.id, i].join('_'),
                                                                    '">',
                                                                    '<strong data-balloon-visible data-balloon="', e.name, '" data-balloon-pos="up" data-balloon-type="marker">',
                                                                    i + 1,
                                                                    '</strong>',
                                                                    SVG_MARKER_ICON[e.type],
                                                                    '</div>'].join('')}
                                                        }
                                                        onClick={() => {
                                                            this.chooseNaverPlace(e)
                                                        }}
                                                />
                                            )
                                        })
                                        :
                                        null
                                }

                                {
                                    this.state.gpsLocation ?
                                        <Marker position={new this.naverMaps.LatLng(this.state.gpsLocation.y, this.state.gpsLocation.x)}
                                                icon= {{content: ['<div class="naver-map-pin-gps-location"', '</div>'].join('')}}
                                        />
                                        :
                                        null
                                }

                                {
                                    this.state.targetToMapCenter ?
                                        <Marker position={new this.naverMaps.LatLng(this.state.targetToMapCenter.y, this.state.targetToMapCenter.x)}
                                                icon= {{content: ['<div class="naver-map-target-to-map-center"', '</div>'].join('')}}
                                        />
                                        :
                                        null
                                }

                                {
                                    this.state.showExpectedSchedule && this.state.expectedScheduleActionSheet.list !== 0 ?
                                        <Polyline
                                            path={naverMapPolyLineList}
                                            strokeColor={'#ffe336'}
                                            strokeStyle={'solid'}
                                            strokeOpacity={0.8}
                                            strokeWeight={3}
                                        />
                                        :
                                        null
                                }
                            </NaverMap>

                            <ul className={["list list--material create-plan-list", this.state.lockMapArea ? "create-plan-list-lock-map" : ""].join(" ")}>
                                <li className="list-header">
                                    <span className="create-plan-setting-button-title"><i className="fa fa-cog"/> 지도 설정</span>
                                    {
                                        this.state.showExpectedSchedule ?
                                            <span className="create-plan-setting-button" onClick={() => this.setState({showExpectedSchedule: false})}>내 일정 보기</span>
                                            :
                                            <span className="create-plan-setting-button create-plan-setting-button-disabled" onClick={() => this.setState({showExpectedSchedule: true})}>내 일정 숨김</span>
                                    }
                                    {
                                        this.state.showPlaceLabel ?
                                            <span className="create-plan-setting-button" onClick={() => this.setState({showPlaceLabel: false})}>지명 보기</span>
                                            :
                                            <span className="create-plan-setting-button create-plan-setting-button-disabled" onClick={() => this.setState({showPlaceLabel: true})}>지명 숨김</span>
                                    }
                                    {
                                        this.state.lockMapArea ?
                                            <span className="create-plan-setting-button" onClick={() => this.setState({lockMapArea: false})}>지도 고정</span>
                                            :
                                            <span className="create-plan-setting-button create-plan-setting-button-disabled" onClick={() => this.setState({lockMapArea: true})}>고정 해제</span>
                                    }
                                </li>

                                {this.getSearchTypeList()}

                                {
                                    this.state.searchedPlaces.isLoading ?
                                        <div className='create-plan-map-list-loader-puff'>
                                            <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                        </div>
                                        :
                                        this.state.searchedPlaces[this.state.tabBarTarget].map((e, i) => {
                                            return (
                                                <li key={['list', e.id, i].join('_')} className="list-item list-item--material">
                                                    <div className="list-item__left list-item--material__left" onClick={() => this.chooseNaverPlace(e)}>
                                                        <img className="list-item__thumbnail" src={NAVER_THUMBNAIL_GETTER(e)} onError={(e)=>{e.target.src = "https://fakeimg.pl/100x100/?text=No Image"}} alt={e.name}/>
                                                    </div>
                                                    <div className="list-item__center list-item--material__center" onClick={() => this.chooseNaverPlace(e)}>
                                                        <div className="list-item__title list-item--material__title">
                                                            {i + 1}. {e.name} {e.category ? <small>{e.category}</small>: null}
                                                            <i className="fa fa-map-marker-alt" onClick={(event) => this.setTargetToMapCenter(event, e)}/>
                                                        </div>
                                                        <div className="list-item__subtitle list-item--material__subtitle">{e.tags ? e.tags.join(", ") : null}</div>
                                                    </div>
                                                    <div className="list-item__right list-item--material__right" onClick={(event) => this.showNaverPlaceReviewsActionSheet(event, e)}>
                                                        <span className="notification notification--material">{e.blogCafeReviewCount ? e.blogCafeReviewCount : e.totalReviewCount}</span>
                                                        <i className="fa fa-plus" onClick={(event) => this.addExpectedSchedule(event, e, null)}/>
                                                    </div>
                                                </li>
                                            )
                                        })
                                }

                                {
                                    !this.state.searchedPlaces.isLoading ?
                                        this.state.searchedPlaces.total === 0 ?
                                            <li className="list-item list-item--material">
                                                <div className="list-item__center list-item--material__center">
                                                    <div className="list-item__title list-item--material__title text-center">
                                                        현재 조건에서 검색된 항목이 없습니다.
                                                    </div>
                                                </div>
                                            </li>
                                            :
                                            this.state.searchedPlaces.total > parseInt(this.state.searchCount) ?
                                                <li className="list-item list-item--material">
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title list-item--material__title text-center">
                                                            {
                                                                [...Array(this.state.searchedPlaces.total > parseInt(this.state.searchCount) * 10 ? 10 : parseInt(this.state.searchedPlaces.total / parseInt(this.state.searchCount)) + 1)].map((e, i) => {
                                                                    return <a className={['search-place-pagination-button', this.state.searchedPlaces.index === i ? 'search-place-pagination-button-selected' : ''].join(' ')} key={['search_place_pagination', i].join('_')}  onClick={() => this.paginationSearchPlace(i)}>{i + 1}</a>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                null
                                        :
                                        null
                                }
                            </ul>
                        </div>

                        <div className="tabbar tabbar--material create-plan-tabbar">
                            <label className="tabbar__item tabbar--material__item TUTO_CREATE_PLAN_TAB_PLAYING">
                                <input type="radio" name="tabbar-material-c" onChange={() => this.changeTabBarTarget('playing')} checked={this.state.tabBarTarget === 'playing' ? 'checked' : ''}/>
                                <button className="tabbar__button tabbar--material__button">
                                    {
                                        this.state.tabBarTarget === 'playing' ?
                                            <span className="notification notification--material create-plan-tabbar-notification">{this.state.searchedPlaces.total}</span>
                                            :
                                            null
                                    }
                                    <i className="tabbar__icon tabbar--material__icon fa fa-bowling-ball"/>
                                    <div className="tabbar__label tabbar--material__label">놀곳</div>
                                </button>
                            </label>
                            <label className="tabbar__item tabbar--material__item">
                                <input type="radio" name="tabbar-material-c" onChange={() => this.changeTabBarTarget('eating')} checked={this.state.tabBarTarget === 'eating' ? 'checked' : ''}/>
                                <button className="tabbar__button tabbar--material__button">
                                    {
                                        this.state.tabBarTarget === 'eating' ?
                                            <span className="notification notification--material create-plan-tabbar-notification">{this.state.searchedPlaces.total}</span>
                                            :
                                            null
                                    }
                                    <i className="tabbar__icon tabbar--material__icon fa fa-utensils"/>
                                    <div className="tabbar__label tabbar--material__label">먹을곳</div>
                                </button>
                            </label>
                            <label className="tabbar__item tabbar--material__item">
                                <input type="radio" name="tabbar-material-c" onChange={() => this.changeTabBarTarget('accommodation')} checked={this.state.tabBarTarget === 'accommodation' ? 'checked' : ''}/>
                                <button className="tabbar__button tabbar--material__button">
                                    {
                                        this.state.tabBarTarget === 'accommodation' ?
                                            <span className="notification notification--material create-plan-tabbar-notification">{this.state.searchedPlaces.total}</span>
                                            :
                                            null
                                    }
                                    <i className="tabbar__icon tabbar--material__icon fa fa-bed"/>
                                    <div className="tabbar__label tabbar--material__label">잘곳</div>
                                </button>
                            </label>
                            <label className="tabbar__item tabbar--material__item expected-plan-label TUTO_CREATE_PLAN_TAB_SHOW_EXPECTED_SCHEDULE">
                                <input type="radio" name="tabbar-material-expected-plan" onChange={this.showExpectedScheduleActionSheet} checked={esas.open ? 'checked' : ''}/>
                                <button className="tabbar__button tabbar--material__button">
                                    <span className="notification notification--material expected-plan-label-notification">{esas.list.length}</span>
                                    <i className="tabbar__icon tabbar--material__icon fa fa-clipboard-list"/>
                                    <div className="tabbar__label tabbar--material__label">일정 보기</div>
                                </button>
                            </label>
                        </div>

                        {
                            this.state.searchTypeActionSheet.open ?
                                <ActionSheet className="create-plan-action-sheet" isOpen={this.state.searchTypeActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({searchTypeActionSheet: {...this.state.searchTypeActionSheet, open: false}})} isCancelable={true} title={this.state.searchTypeActionSheet.title}>
                                    {
                                        this.state.searchTypeActionSheet.list && this.state.searchTypeActionSheet.list[this.state.searchTypeActionSheet.target] ?
                                            this.state.searchTypeActionSheet.list[this.state.searchTypeActionSheet.target].map((element, i) => {
                                                return (
                                                    <ActionSheetButton key={[element.cid, i].join('_')} class={this.state.searchTypeActionSheet.selected[this.state.searchTypeActionSheet.target].cid === element.cid ? 'create-plan-action-sheet-selected' : ''} modifier={'material'} onClick={() => this.selectSearchType(this.state.searchTypeActionSheet.target, element.cid)}>{element.name} <small>{this.state.searchTypeActionSheet.selected[this.state.searchTypeActionSheet.target].cid === element.cid ? '(선택됨)' : ''}</small></ActionSheetButton>
                                                )
                                            })
                                            :
                                            null
                                    }
                                    <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({searchTypeActionSheet: {...this.state.searchTypeActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>종류 닫기</ActionSheetButton>
                                </ActionSheet>
                                :
                                null
                        }

                        {
                            esas.open ?
                                <ActionSheet className="create-plan-expected-plan-action-sheet" isOpen={esas.open} animation='default' modifier={'material'} onCancel={() => this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, open: false}})} isCancelable={true}>
                                    <div className="action-sheet-title action-sheet-title--material">
                                        나들이 일정 {esas.list.length}개
                                        <button className="button--material--flat" onClick={() => this.setState({showExpectedScheduleSetting: this.state.showExpectedScheduleSetting ? false: true})}>
                                            {this.state.showExpectedScheduleSetting ? <span>설정 감추기</span> : <span>설정 보기</span>}
                                        </button>
                                        <button className="button--material--flat" onClick={() => this.setState({interestingPlaceActionSheet: {...this.state.interestingPlaceActionSheet, open: true}})}>
                                            <span>관심 장소 추가</span>
                                        </button>
                                    </div>
                                    <ul className="list list--material expected-plan-list">
                                        {
                                            esas.list.length === 0 ?
                                                <li className="list-item list-item--material">
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title list-item--material__title text-center">
                                                            추가한 일정 항목이 없습니다.
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                null
                                        }

                                        {
                                            esas.list.map((e, i) => {
                                                return (
                                                    <li key={['expected', 'plan', e.id, i].join('_')} className="list-item list-item--material">
                                                        <ul className="list list--material">
                                                            <li className="list-item list-item--material">
                                                                <div className="list-item__left list-item--material__left" onClick={() => this.chooseNaverPlace(e)}>
                                                                    <img className="list-item__thumbnail" src={NAVER_THUMBNAIL_GETTER(e)} onError={(e)=>{e.target.src = "https://fakeimg.pl/100x100/?text=No Image"}} alt={e.name}/>
                                                                </div>
                                                                <div className="list-item__center list-item--material__center" onClick={() => this.chooseNaverPlace(e)}>
                                                                    <div className="list-item__title list-item--material__title">{i + 1}. {e.name}</div>
                                                                    <div className="list-item__subtitle list-item--material__subtitle">
                                                                        {
                                                                            e.distanceFrom ?
                                                                                <div><small>앞 일정과 직선거리: </small> {e.distanceFrom}</div>
                                                                                :
                                                                                null
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {
                                                                    this.state.showExpectedScheduleSetting ?
                                                                        <div className="list-item__right list-item--material__right">
                                                                            <span className={['notification', 'notification--material', 'notification-category'].join(' ')}>{e.category ?  e.category.split(',').join(', ') : '없음'}</span>
                                                                            {
                                                                                i !== 0 ?
                                                                                    <a onClick={() => this.changeOrderExpectedSchedule('up', i)}><i className="fa fa-arrow-circle-up"/></a>
                                                                                    :
                                                                                    <a style={{opacity: 0.2}}><i className="fa fa-arrow-circle-up"/></a>
                                                                            }
                                                                            {
                                                                                i !== esas.list.length - 1 ?
                                                                                    <a onClick={() => this.changeOrderExpectedSchedule('down', i)}><i className="fa fa-arrow-circle-down"/></a>
                                                                                    :
                                                                                    <a style={{opacity: 0.2}}><i className="fa fa-arrow-circle-down"/></a>
                                                                            }
                                                                            <a onClick={() => this.deleteExpectedSchedule(i)}><i className="fa fa-minus"/></a>
                                                                        </div>
                                                                        :
                                                                        <div className="list-item__right list-item--material__right">
                                                                            <span className={['notification', 'notification--material', 'notification-category'].join(' ')}>{e.category ?  e.category.split(',').join(', ') : '없음'}</span>
                                                                        </div>
                                                                }
                                                            </li>
                                                            <li className="list-item list-item--material expected-plan-list-textarea-wrapper">
                                                                <div className="list-item__center">
                                                                    <textarea className="textarea textarea--transparent" rows={1} placeholder={e.name + '에 관한 설명을 입력하세요.'} value={e.userComment} onChange={(event) => this.fillInFormInElement('elementUserComment', i, event)}/>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                    {
                                        esas.list.length !== 0 ?
                                            <ul className="list list--material create-plan-naver-place-save-schedule-wrapper">
                                                {
                                                    esas.gpsFrom ?
                                                        <li className="list-item list-item--material create-plan-naver-place-save-schedule-distance">
                                                            <div className="list-item__center">
                                                                <div className="list-item__title">
                                                                    내 위치와의 거리
                                                                    <button className="button--quiet create-plan-map-current-button" onClick={this.requestCurrentLocation}>
                                                                        <i className="ion ion-android-locate"/>
                                                                    </button>
                                                                </div>
                                                                {
                                                                    esas.gpsFrom.hasGps ?
                                                                        <div className="list-item__subtitle">
                                                                            <p><small>내 위치로부터 시작점인 </small>{esas.list[0].name}<small>{GET_JOSA(esas.list[0].name, '과')}</small> {esas.gpsFrom.start}</p>
                                                                            <p><small>내 위치로부터 도착점인 </small>{esas.list[esas.list.length - 1].name}<small>{GET_JOSA(esas.list[esas.list.length - 1].name, '과')}</small> {esas.gpsFrom.last}</p>
                                                                        </div>
                                                                        :
                                                                        <div className="list-item__subtitle">
                                                                            <p>
                                                                                <small>가져온 GPS 정보가 없습니다.</small>
                                                                                &nbsp;
                                                                                <small>GPS 정보 가져오기 →</small>
                                                                                <button className="button--quiet create-plan-map-current-button" onClick={this.requestCurrentLocation}>
                                                                                    <i className="ion ion-android-locate"/>
                                                                                </button>
                                                                            </p>
                                                                        </div>
                                                                }
                                                            </div>
                                                        </li>
                                                        :
                                                        null
                                                }
                                                <li className="list-item list-item--material text-center create-plan-naver-place-save-schedule-button-wrapper">
                                                    <div>
                                                        <button className="button button--material--flat" onClick={this.showTrafficCondition}><i className="fa fa-road"/> 경로</button>
                                                    </div>
                                                    <div className="create-plan-naver-place-save-schedule-button">
                                                        <button className="button button--material--flat TUTO_CREATE_SAVE_SCHEDULE_BUTTON" onClick={this.openSaveScheduleDialog}><i className="fa fa-save"/> 일정 저장</button>
                                                    </div>
                                                </li>
                                            </ul>
                                            :
                                            <ul className="list list--material create-plan-naver-place-save-schedule-wrapper"><li></li></ul>
                                    }
                                    <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({expectedScheduleActionSheet: {...this.state.expectedScheduleActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>일정 닫기</ActionSheetButton>
                                </ActionSheet>
                                :
                                null
                        }

                        {
                            this.state.iframeActionSheet.open ?
                                <ActionSheet className="iframe-action-sheet" isOpen={this.state.iframeActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} isCancelable={true} title={'이하 정보는 네이버 사이트입니다.'}>
                                    <iframe id="iframe-action-sheet" title="iframe-action-sheet" src={this.state.iframeActionSheet.frameUrl}></iframe>
                                    <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                                </ActionSheet>
                                :
                                null
                        }

                        {
                            this.state.expectedScheduleWithTypeSelectionActionSheet.open ?
                                <ActionSheet className="expected-schedule-with-type-selection-action-sheet" isOpen={this.state.expectedScheduleWithTypeSelectionActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({expectedScheduleWithTypeSelectionActionSheet: {...this.state.expectedScheduleWithTypeSelectionActionSheet, open: false}})} isCancelable={true} title={'일정 타입 선택'}>
                                    <ActionSheetButton modifier={'material'} onClick={(event) => this.addExpectedSchedule(event, this.state.expectedScheduleWithTypeSelectionActionSheet.target, 'playing')}><i className="fa fa-bowling-ball"/> 놀곳</ActionSheetButton>
                                    <ActionSheetButton modifier={'material'} onClick={(event) => this.addExpectedSchedule(event, this.state.expectedScheduleWithTypeSelectionActionSheet.target, 'eating')}><i className="fa fa-utensils"/> 먹을곳</ActionSheetButton>
                                    <ActionSheetButton modifier={'material'} onClick={(event) => this.addExpectedSchedule(event, this.state.expectedScheduleWithTypeSelectionActionSheet.target, 'accommodation')}><i className="fa fa-bed"/> 잘곳</ActionSheetButton>
                                    <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({expectedScheduleWithTypeSelectionActionSheet: {...this.state.expectedScheduleWithTypeSelectionActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>닫기</ActionSheetButton>
                                </ActionSheet>
                                :
                                null
                        }


                        {
                            this.state.searchPlaceActionSheet.open ?
                                <ActionSheet className={["search-place-action-sheet", this.state.searchPlaceActionSheet.onFocus ? 'search-place-action-sheet-on-focus' : ''].join(" ")} isOpen={this.state.searchPlaceActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, open: false}})} isCancelable={true}>
                                    <div className="action-sheet-title action-sheet-title--material">
                                        장소 검색
                                        <button className="button--quiet create-plan-map-current-button" onClick={this.requestCurrentLocation}>
                                            <i className="ion ion-android-locate"/>
                                        </button>
                                    </div>
                                    <ul className="list list--material search-place-list">
                                        <li className="list-item list-item--material search-place-range-wrapper">
                                            <div className="segment segment--material">
                                                <div className="segment__item segment--material__item">
                                                    <input type="radio" className="segment__input segment--material__input" name="search-place-range" onChange={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, range: 0}})} checked={this.state.searchPlaceActionSheet.range === 0 ? 'checked' : ''}/>
                                                    <div className="segment__button segment--material__button">전체</div>
                                                </div>
                                                <div className="segment__item segment--material__item">
                                                    <input type="radio" className="segment__input segment--material__input" name="search-place-range" onChange={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, range: 10}})} checked={this.state.searchPlaceActionSheet.range === 10 ? 'checked' : ''}/>
                                                    <div className="segment__button segment--material__button">10km 내</div>
                                                </div>
                                                <div className="segment__item segment--material__item">
                                                    <input type="radio" className="segment__input segment--material__input" name="search-place-range" onChange={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, range: 20}})} checked={this.state.searchPlaceActionSheet.range === 20 ? 'checked' : ''}/>
                                                    <div className="segment__button segment--material__button">20km 내</div>
                                                </div>
                                                {/*<div className="segment__item segment--material__item">
                                                    <input type="radio" className="segment__input segment--material__input" name="search-place-range" onChange={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, range: 50}})} checked={this.state.searchPlaceActionSheet.range === 50 ? 'checked' : ''}/>
                                                    <div className="segment__button segment--material__button">50km 내</div>
                                                </div>*/}
                                            </div>
                                        </li>
                                        <li className="list-item list-item--material search-place-input-wrapper">
                                            <form onSubmit={(e) => this.searchPlaceWithText(e)}>
                                                <input type="search" placeholder="장소 이름" className="search-input search-input--material" value={this.state.searchPlaceActionSheet.text}
                                                       onChange={(e) => this.fillInForm('searchPlace', e)}
                                                       /*onFocus={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, onFocus: true}})}
                                                       onBlur={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, onFocus: false}})}*/
                                                />
                                                <button className="button button--material" onClick={(e) => this.searchPlaceWithText(e)}>검색</button>
                                            </form>
                                         </li>
                                        {
                                            !this.state.searchPlaceActionSheet.isLoading && this.state.searchPlaceActionSheet.list.length === 0 ?
                                                <li className="list-item list-item--material">
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title list-item--material__title text-center">
                                                            검색된 장소가 없습니다.
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                null
                                        }

                                        {
                                            this.state.searchPlaceActionSheet.list.map((e, i) => {
                                                return (
                                                    <li key={['searched', 'place', e.id, i].join('_')} className="list-item list-item--material" >
                                                        <div className="list-item__left list-item--material__left" onClick={() => this.chooseNaverPlace(e)}>
                                                            <img className="list-item__thumbnail" src={NAVER_THUMBNAIL_GETTER(e)} alt={e.name} onError={(event)=>{event.target.src = "https://fakeimg.pl/100x100/?text=No Image"}}/>
                                                        </div>
                                                        <div className="list-item__center list-item--material__center" onClick={() => this.chooseNaverPlace(e)}>
                                                            <div className="list-item__title list-item--material__title">{i + 1}. {e.name} {e.category ? <small>{e.category}</small>: null}</div>
                                                            <div className="list-item__subtitle list-item--material__subtitle">{e.roadAddr || e.addr ? e.roadAddr ? e.roadAddr : e.addr : null}</div>
                                                        </div>
                                                        <div className="list-item__right list-item--material__right" onClick={(event) => this.showNaverPlaceReviewsActionSheet(event, e)}>
                                                            <span className="notification notification--material">{e.blogCafeReviewCount ? e.blogCafeReviewCount : e.totalReviewCount}</span>
                                                            <i className="fa fa-plus" onClick={(event) => this.addExpectedScheduleWithTypeSelection(event, e)}/>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }

                                        {
                                            this.state.searchPlaceActionSheet.isLoading ?
                                                <li className="list-item list-item--material">
                                                    <div className="list-item__center list-item--material__center">
                                                        <div className="list-item__title list-item--material__title text-center">
                                                            <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                null
                                        }
                                    </ul>
                                    <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({searchPlaceActionSheet: {...this.state.searchPlaceActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>장소 검색 닫기</ActionSheetButton>
                                </ActionSheet>
                                :
                                null
                        }

                        {
                            this.state.trafficConditionActionSheet.open ?
                                <ActionSheet className="traffic-condition-action-sheet" isOpen={this.state.trafficConditionActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, open: false}})} isCancelable={true}>
                                    <div className="action-sheet-title action-sheet-title--material">
                                        경로
                                    </div>
                                    <ul className="list list--material traffic-condition-list">
                                        {
                                            this.state.trafficConditionActionSheet.list.map((e, i) => {
                                                return (
                                                    <li key={['traffic', 'condition', i].join('_')} className="list-item list-item--material" onClick={() => this.setState({iframeActionSheet: {open: true, frameUrl: e.url}})}>
                                                        <div className="list-item__center list-item--material__center">
                                                            <div className="list-item__title list-item--material__title">{e.route}</div>
                                                        </div>
                                                        <div className="list-item__right list-item--material__right">
                                                            <button className="fab fab--mini route-button"><i className="fa fa-directions"/></button>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                    <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>경로 닫기</ActionSheetButton>
                                </ActionSheet>
                                :
                                null
                        }

                        {
                            this.state.naverPlaceReviewsActionSheet.open ?
                                <NaverPlaceReviewsActionSheet targetMarker={this.state.naverPlaceReviewsActionSheet.targetMarker} hide={() => this.setState({naverPlaceReviewsActionSheet: {...this.state.naverPlaceReviewsActionSheet, open: false}})}/>
                                :
                                null
                        }

                        {
                            this.state.roadViewActionSheet.open ?
                                <RoadViewActionSheet open={this.state.roadViewActionSheet.open} frameUrl={this.state.roadViewActionSheet.frameUrl} hide={() => this.setState({roadViewActionSheet: {...this.state.roadViewActionSheet, open: false}})}/>
                                :
                                null
                        }

                        {
                            this.state.interestingPlaceActionSheet.open ?
                                <InterestingPlaceActionSheet open={this.state.interestingPlaceActionSheet.open} importable={true} importSchedule={this.addExpectedSchedule} hide={() => this.setState({interestingPlaceActionSheet: {...this.state.interestingPlaceActionSheet, open: false}})}/>
                                :
                                null
                        }

                        {
                            tnpas.open ?
                                <ActionSheet className="create-plan-naver-place-action-sheet" isOpen={tnpas.open} aanimation='default' modifier={'material'} onCancel={() => this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, open: false}})} isCancelable={true}>
                                    <div className="action-sheet-title action-sheet-title--material create-plan-naver-place-action-sheet-title">{tnpas.targetMarker ? tnpas.targetMarker.name : null} <small>(사이트: 네이버 플레이스)</small></div>
                                    {/*<div className="card card--material">
                                        <NaverMap
                                            id={'naver-map-for-target'}
                                            className={'create-plan-naver-map-for-target'}
                                            style={tnpas.chosenThumbnailType === 'map' ? {width: window.innerWidth, height: '300px'} : {width: window.innerWidth, height: '300px', display: 'none'}}
                                            defaultZoom={10}
                                            minZoom={3}
                                            maxZoom={14}
                                            zoomControl={true}
                                            zoomControlOptions={
                                                {position: this.naverMaps.Position.TOP_RIGHT}
                                            }
                                            center={tnpas.targetMarker ? {lat: tnpas.targetMarker.y, lng: tnpas.targetMarker.x} : this.state.mapCenter}

                                            logoControl={false}
                                            mapDataControl={false}
                                        >
                                            {
                                                tnpas.targetMarker ?
                                                    <Marker position={new this.naverMaps.LatLng(tnpas.targetMarker.y, tnpas.targetMarker.x)}
                                                            animation={this.naverMaps.Animation.BOUNCE}
                                                    />
                                                    :
                                                    null

                                            }

                                            {
                                                this.state.showExpectedSchedule ?
                                                    esas.list.map((e, i) => {
                                                        return (
                                                            <Marker key={['scheduled', 'marker', 'for', 'target', e.id, i].join('_')}
                                                                    position={new this.naverMaps.LatLng(e.y, e.x)}
                                                                    icon= {
                                                                        {content: ['<div class="naver-map-pin naver-map-pin-mine"',
                                                                                'id="',
                                                                                ['scheduled', 'marker', 'for', 'target', e.id, i].join('_'),
                                                                                '">',
                                                                                SVG_MARKER_ICON[e.type],
                                                                                '</div>'].join('')}
                                                                    }
                                                                    onClick={() => {
                                                                        this.setState({targetNaverPlacePopover: {target: document.getElementById(['scheduled', 'marker', 'for', 'target', e.id, i].join('_')), text: e.name, category: e.category, open: true}})
                                                                    }}
                                                            />
                                                        )
                                                    })
                                                    :
                                                     null
                                            }
                                        </NaverMap>

                                        {
                                            tnpas.open ?
                                                <div>
                                                    <img className="naver-place-action-sheet-main-image"
                                                         src={tnpas.targetMarker.imageSrc ? 'https://search.pstatic.net/common/?autoRotate=true&quality=95&size=750x448&src=' + tnpas.targetMarker.imageSrc + '&type=l' : 'https://fakeimg.pl/750x448/?text=No Image'}
                                                         onError={(e) => {
                                                             e.target.src = "https://fakeimg.pl/750x448/?text=No Image"
                                                         }}
                                                         style={tnpas.chosenThumbnailType === 'map' ? {display: 'none'} : {}}
                                                         alt={tnpas.targetMarker.name}/>

                                                    <div className="segment segment--material" style={{width: '100%'}}>
                                                        <div className="segment__item segment--material__item">
                                                            <input type="radio" className="segment__input segment--material__input" name="naver-place-action-sheet-chosen-thumbnail-type"
                                                                   onChange={() => this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, chosenThumbnailType: 'map'}})}
                                                                   checked={tnpas.chosenThumbnailType === 'map' ? 'checked' : ''}/>
                                                            <div className="segment__button segment--material__button">지도</div>
                                                        </div>
                                                        <div className="segment__item segment--material__item">
                                                            <input type="radio" className="segment__input segment--material__input" name="naver-place-action-sheet-chosen-thumbnail-type"
                                                                   onChange={() => this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, chosenThumbnailType: 'pic'}})}
                                                                   checked={tnpas.chosenThumbnailType === 'pic' ? 'checked' : ''}/>
                                                            <div className="segment__button segment--material__button">사진</div>
                                                        </div>
                                                    </div>

                                                    <div className="card__content card--material__content">
                                                        <div className="tabbar tabbar--top tabbar--material">
                                                            <label className="tabbar__item tabbar--material__item">
                                                                    <button className="tabbar__button tabbar--material__button" onClick={(event) => this.showNaverPlaceReviews(event, tnpas.targetMarker, 1)}>
                                                                        <i className="tabbar__icon tabbar--material__icon fa fa-comments"></i>
                                                                        <div className="tabbar__label tabbar--material__label">리뷰</div>
                                                                    </button>
                                                            </label>
                                                            <label className="tabbar__item tabbar--material__item">

                                                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.setState({iframeActionSheet: {open: true, frameUrl: 'https://m.store.naver.com/attractions/detail?id=' + tnpas.targetMarker.id + '&back=false'}})}>
                                                                        <i className="tabbar__icon tabbar--material__icon zmdi zmdi-view-web"></i>
                                                                        <div className="tabbar__label tabbar--material__label">플레이스</div>
                                                                    </button>
                                                            </label>
                                                            <label className="tabbar__item tabbar--material__item">
                                                                {
                                                                    tnpas.targetMarker.streetViewUrl ?
                                                                        <button className="tabbar__button tabbar--material__button" onClick={() => this.openExternalLink(tnpas.targetMarker.streetViewUrl)}>
                                                                            <i className="tabbar__icon tabbar--material__icon fa fa-road"></i>
                                                                            <div className="tabbar__label tabbar--material__label">로드뷰</div>
                                                                        </button>
                                                                        :
                                                                        <button className="tabbar__button tabbar--material__button" disabled={true}>
                                                                            <i className="tabbar__icon tabbar--material__icon fa fa-road"></i>
                                                                            <div className="tabbar__label tabbar--material__label">로드뷰</div>
                                                                        </button>
                                                                }
                                                            </label>
                                                        </div>

                                                        <div className="text-center">
                                                            <button className="button button--material create-plan-naver-place-add-schedule" onClick={(event) => this.addExpectedSchedule(event, tnpas.targetMarker)}><i className="fa fa-plus"/> 일정에 담기</button>
                                                        </div>

                                                        {tnpas.targetMarker.addr || tnpas.targetMarker.roadAddr ?
                                                            <ul className="list list--material naver-place-detail-list">
                                                                <li className="list-header">주소</li>
                                                                <li className="list-item list-item--material">
                                                                    {tnpas.targetMarker.roadAddr ? tnpas.targetMarker.roadAddr : tnpas.targetMarker.addr}
                                                                </li>
                                                            </ul>
                                                            :
                                                            null
                                                        }
                                                        {
                                                            tnpas.isLoading ?
                                                                <ul className="list list--material naver-place-detail-list">
                                                                    <li className="list-item list-item--material">
                                                                        <div className="list-item__center list-item--material__center">
                                                                            <div className="list-item__title list-item--material__title text-center">
                                                                                <Loader type="ThreeDots" color="#00BFFF" height={40} width={40}/>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            tnpas.targetMarker.desc ?
                                                                <ul className="list list--material naver-place-detail-list">
                                                                    <li className="list-header">설명</li>
                                                                    <li className="list-item list-item--material">
                                                                        {tnpas.targetMarker.desc}
                                                                    </li>
                                                                </ul>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            tnpas.targetMarker.phone ?
                                                                <ul className="list list--material naver-place-detail-list">
                                                                    <li className="list-header">전화</li>
                                                                    <li className="list-item list-item--material">
                                                                        {tnpas.targetMarker.phone}
                                                                    </li>
                                                                </ul>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            tnpas.targetMarker.tags && tnpas.targetMarker.tags.length !== 0 ?
                                                                <ul className="list list--material naver-place-detail-list">
                                                                    <li className="list-header">키워드</li>
                                                                    <li className="list-item list-item--material">
                                                                        {tnpas.targetMarker.tags.join(", ")}
                                                                    </li>
                                                                </ul>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                :
                                                <div/>
                                        }
                                    </div>*/}

                                    <div className="card card--material">
                                        <div className="create-plan-naver-place-iframe-wrapper">
                                            <iframe title="naver-place-iframe" src={tnpas.open ? 'https://m.store.naver.com/attractions/detail?id=' + tnpas.targetMarker.id + '&back=false' : null}/>
                                        </div>
                                        {
                                            tnpas.open ?
                                                <div className="text-center create-plan-naver-place-add-schedule-wrapper">
                                                    <div className="tabbar tabbar--top tabbar--material">
                                                        <label className="tabbar__item tabbar--material__item">
                                                            <button className="tabbar__button tabbar--material__button" onClick={(event) => this.showNaverPlaceReviewsActionSheet(event, tnpas.targetMarker)}>
                                                                <i className="tabbar__icon tabbar--material__icon fa fa-comments"></i>
                                                                <div className="tabbar__label tabbar--material__label">리뷰</div>
                                                            </button>
                                                        </label>
                                                        <label className="tabbar__item tabbar--material__item">
                                                            <button className="tabbar__button tabbar--material__button" onClick={() => this.setState({roadViewActionSheet: {open: true, frameUrl: ['https://m.map.naver.com/viewer/panorama.nhn?street=on&pinType=site&pinId=', tnpas.targetMarker.id].join('')}})}>
                                                                <i className="tabbar__icon tabbar--material__icon fa fa-road"></i>
                                                                <div className="tabbar__label tabbar--material__label">로드뷰</div>
                                                            </button>
                                                        </label>
                                                        <label className="tabbar__item tabbar--material__item">
                                                            <button className="tabbar__button tabbar--material__button" onClick={() => this.addInterestingPlace(tnpas.targetMarker)}>
                                                                <i className="tabbar__icon tabbar--material__icon fa fa-search-plus"></i>
                                                                <div className="tabbar__label tabbar--material__label">관심 장소 등록</div>
                                                            </button>
                                                        </label>
                                                        <label className="tabbar__item tabbar--material__item">
                                                            <button className="tabbar__button tabbar--material__button create-plan-naver-place-add-schedule TUTO_CREATE_ADD_SCHEDULE" onClick={(event) => this.addExpectedSchedule(event, tnpas.targetMarker, null)}>
                                                                <i className="tabbar__icon tabbar--material__icon fa fa-plus"></i>
                                                                <div className="tabbar__label tabbar--material__label">일정에 담기</div>
                                                            </button>
                                                        </label>
                                                    </div>
                                                </div>
                                                :
                                                <div/>
                                        }
                                    </div>
                                    <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                                </ActionSheet>
                            :
                                null
                        }


                        <Popover
                            isOpen={this.state.targetNaverPlacePopover.open}
                            onOpen={() => this.setState({targetNaverPlacePopover: {...this.state.targetNaverPlacePopover, open: true}})}
                            onHide={() => this.setState({targetNaverPlacePopover: {...this.state.targetNaverPlacePopover, open: false}})}
                            onCancel={() => this.setState({targetNaverPlacePopover: {...this.state.targetNaverPlacePopover, open: false}})}
                            isCancelable={true}
                            getTarget={() => this.state.targetNaverPlacePopover.target}
                            className='target-naver-place-popover'
                        >
                            <section>
                                <p>{this.state.targetNaverPlacePopover.text}</p>
                                <p><small>{this.state.targetNaverPlacePopover.category}</small></p>
                            </section>
                        </Popover>

                        <AlertDialog className="create-plan-save-schedule-alert-dialog" isOpen={this.state.saveScheduleDialog.open} onCancel={() => this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, open: false}})} cancelable={true} modifier={'material'}>
                            <div className="alert-dialog-title">일정 저장</div>
                            <div className="alert-dialog-content">
                                <div>
                                    나들이 일정을 저장하시겠습니까?
                                </div>
                                <div>
                                    <input className="text-input text-input--material" placeholder="일정 제목을 입력하세요. (100자 이내)" type="text" value={this.state.saveScheduleDialog.title} onChange={(e) => this.fillInForm('scheduleTitle', e)}/>
                                </div>
                                <div>
                                    <textarea className="textarea textarea--transparent" rows="3" placeholder="필요시 일정 전체에 관한 설명을 입력하세요. (2000자 이내)" value={this.state.saveScheduleDialog.description} onChange={(e) => this.fillInForm('scheduleDescription', e)}></textarea>
                                </div>
                                <div className="black-line"/>
                                <div>
                                    <p style={{fontSize: '14px'}}>대표 썸네일</p>
                                    <div className="create-plan-save-schedule-thumbnail-carousel">
                                        {
                                            this.state.saveScheduleDialog.open ?
                                                <Carousel showStatus={false} showThumbs={false} showIndicators={false} width={'250px'} centerMode={true} centerSlidePercentage={20} autoPlay={false} selectedItem={this.state.saveScheduleDialog.thumbnailIndex}>
                                                    {
                                                        esas.list.map((e, i) => {
                                                            return (
                                                                <div key={['carousel', 'thumbnail', i].join('_')} onClick={() => this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, thumbnailIndex: i}})}>
                                                                    <img className={["list-item__thumbnail", this.state.saveScheduleDialog.thumbnailIndex === i ? "list-item__thumbnail-checked": ""].join(' ')} src={NAVER_THUMBNAIL_GETTER(e)} onError={(e) => {
                                                                        e.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                                    }} alt={e.name}/>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </Carousel>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                <div className="black-line"/>
                                <div className="create-plan-save-sort">
                                    <p>일정 유형 <small> (4개까지 선택 가능합니다.)</small></p>
                                    <Row className="create-plan-save-sort-row">
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.date} onChange={() => this.changeSortOfSchedule('date', !this.state.saveScheduleDialog.sort.date)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                만남 <i className="fa fa-heart"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.picnic} onChange={() => this.changeSortOfSchedule('picnic', !this.state.saveScheduleDialog.sort.picnic)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                소풍 <i className="fa fa-child"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.sightseeing} onChange={() => this.changeSortOfSchedule('sightseeing', !this.state.saveScheduleDialog.sort.sightseeing)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                관광 <i className="fa fa-eye"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.shopping} onChange={() => this.changeSortOfSchedule('shopping', !this.state.saveScheduleDialog.sort.shopping)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                쇼핑 <i className="fa fa-shopping-bag"/>
                                            </label>
                                        </Col>
                                    </Row>
                                    <Row className="create-plan-save-sort-row">
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.eating} onChange={() => this.changeSortOfSchedule('eating', !this.state.saveScheduleDialog.sort.eating)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                먹자 <i className="fa fa-cookie-bite"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.history} onChange={() => this.changeSortOfSchedule('history', !this.state.saveScheduleDialog.sort.history)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                역사 <i className="fa fa-history"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.study} onChange={() => this.changeSortOfSchedule('study', !this.state.saveScheduleDialog.sort.study)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                학습 <i className="fa fa-user-graduate"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.healing} onChange={() => this.changeSortOfSchedule('healing', !this.state.saveScheduleDialog.sort.healing)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                힐링 <i className="fa fa-tree"/>
                                            </label>
                                        </Col>
                                    </Row>
                                    <Row className="create-plan-save-sort-row">
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.activity} onChange={() => this.changeSortOfSchedule('activity', !this.state.saveScheduleDialog.sort.activity)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                활동 <i className="fa fa-walking"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.sport} onChange={() => this.changeSortOfSchedule('sport', !this.state.saveScheduleDialog.sort.sport)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                운동 <i className="fa fa-swimmer"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.outside} onChange={() => this.changeSortOfSchedule('outside', !this.state.saveScheduleDialog.sort.outside)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                실외 <i className="fa fa-door-open"/>
                                            </label>
                                        </Col>
                                        <Col>
                                            <label className="checkbox checkbox--material">
                                                <input type="checkbox" className="checkbox__input checkbox--material__input" checked={this.state.saveScheduleDialog.sort.inside} onChange={() => this.changeSortOfSchedule('inside', !this.state.saveScheduleDialog.sort.inside)}/>
                                                <div className="checkbox__checkmark checkbox--material__checkmark"></div>
                                                실내 <i className="fa fa-door-closed"/>
                                            </label>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="black-line"/>
                                <div className="create-plan-save-schedule-tags" style={this.state.saveScheduleDialog.agree ? {} : {display:'none'}}>
                                    <p>검색어 목록 <small> (장소명은 자동 추가됩니다.)</small></p>
                                    {
                                        this.state.saveScheduleDialog.tags.length === 0 ?
                                            <div className="text-center">
                                                현재 등록된 검색어가 없습니다.
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.state.saveScheduleDialog.tags.map((t, i) => {
                                            return (
                                                <span key={['search', 'tag', i].join('_')} className="notification notification--material" onClick={() => this.deleteSaveScheduleSearchTag(i)}>{t}</span>
                                            )
                                        })
                                    }
                                </div>
                                <div className="create-plan-save-schedule-input-tag" style={this.state.saveScheduleDialog.agree ? {} : {display:'none'}}>
                                    <form onSubmit={(e) => this.addSaveScheduleSearchTag(e)}>
                                        <input className="text-input text-input--material" placeholder="검색에 이용될 검색어를 추가하세요." type="text" value={this.state.saveScheduleDialog.inputTag} onChange={(e) => this.fillInForm('scheduleInputTag', e)}/>
                                        <button className="button button--material" onClick={(e) => this.addSaveScheduleSearchTag(e)}>추가</button>
                                    </form>
                                </div>
                                <div className="text-right">
                                    복사 허용 <Switch modifier={'material'} checked={this.state.saveScheduleDialog.edit} onChange={() => this.changeShareSchedule(!this.state.saveScheduleDialog.edit, 'edit')}/>
                                    공개 허용 <Switch modifier={'material'} checked={this.state.saveScheduleDialog.agree} onChange={() => this.changeShareSchedule(!this.state.saveScheduleDialog.agree, 'share')}/>
                                </div>
                            </div>
                            {
                                !this.state.saveScheduleDialog.isLoading ?
                                    <div className="alert-dialog-footer">
                                        <button className="alert-dialog-button alert-dialog-button-no TUTO_CREATE_SAVE_SCHEDULE_BUTTON_NO" onClick={() => this.setState({saveScheduleDialog: {...this.state.saveScheduleDialog, open: false}})}>
                                            아니요
                                        </button>
                                        <button className="alert-dialog-button alert-dialog-button-yes" onClick={this.saveSchedule}>
                                            예
                                        </button>
                                    </div>
                                    :
                                    <div className="alert-dialog-footer">
                                        <div className='text-center'>
                                            <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                        </div>
                                    </div>
                            }
                        </AlertDialog>
                    </Page>
                </SplitterContent>
            </Splitter>
        )
    }
}

const mapStateToProps = ({ user, native }) => ({
    userInfo: user.userInfo,
    usedSearchNaverPlaceData: native.usedSearchNaverPlaceData,
    searchNaverPlaceTarget: native.searchNaverPlaceTarget,
    searchNaverPlaceData: native.searchNaverPlaceData,
    usedNaverPlaceApiData: native.usedNaverPlaceApiData,
    naverPlaceApiTarget: native.naverPlaceApiTarget,
    naverPlaceApiData: native.naverPlaceApiData,
    usedNaverTrafficConditionData: native.usedNaverTrafficConditionData,
    naverTrafficConditionTarget: native.naverTrafficConditionTarget,
    naverTrafficConditionData: native.naverTrafficConditionData,
    usedCurrentLocation: native.usedCurrentLocation,
    currentLocation: native.currentLocation,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    useSearchNaverPlaceData: () => dispatch(useSearchNaverPlaceData()),
    useNaverPlaceApiData: () => dispatch(useNaverPlaceApiData()),
    useCurrentLocation: () => dispatch(useCurrentLocation()),
    showTutorial: (sort) => dispatch(showTutorial(sort)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateSchedule))